import getConfig from '../config/index';

const config = getConfig();
export const baseRoute = config.baseUrl;
export const IMAGES_BASE_URL = config.imagesUrl;
export const mainRoute = config.mainDomain;
export const passportKey = config.passportKey;
export const clientId = config.clientId;